// IBANDisplay.jsx - IBAN bilgisini göster
import React, { useState } from 'react';

const IBANDisplay = ({ iban }) => {
  const [copied, setCopied] = useState(false);

  if (!iban) {
    return null;
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(iban.number);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-blue-100 flex items-center">
        <svg className="w-6 h-6 mr-2 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
        Ödeme Bilgileri
      </h3>

      <div className="p-5 bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-lg border border-purple-700/50">
        {/* IBAN */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-purple-200 mb-2">
            IBAN Numarası
          </label>
          <div className="flex items-center gap-2">
            <div className="flex-1 p-3 bg-gray-900/50 rounded font-mono text-lg text-white border border-gray-700">
              {iban.number}
            </div>
            <button
              onClick={handleCopy}
              className={`
                px-4 py-3 rounded transition-all duration-200 flex items-center
                ${copied 
                  ? 'bg-green-600 text-white' 
                  : 'bg-blue-600 hover:bg-blue-500 text-white'
                }
              `}
            >
              {copied ? (
                <>
                  <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Kopyalandı
                </>
              ) : (
                <>
                  <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  Kopyala
                </>
              )}
            </button>
          </div>
        </div>

        {/* Alıcı Adı */}
        <div>
          <label className="block text-sm font-semibold text-purple-200 mb-2">
            Alıcı Adı
          </label>
          <div className="p-3 bg-gray-900/50 rounded text-white border border-gray-700">
            {iban.name}
          </div>
        </div>
      </div>

      {/* Ödeme Talimatları */}
      <div className="p-4 bg-yellow-900/20 border border-yellow-700/50 rounded-lg">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div className="text-sm text-yellow-200">
            <strong>Ödeme Adımları:</strong>
            <ol className="list-decimal list-inside mt-2 space-y-1">
              <li>Yukarıdaki IBAN'a toplam ücreti havale yapın</li>
              <li>Rezervasyonu oluşturduktan sonra dekont yükleme ekranı gelecek</li>
              <li>Dekontunuzu yükleyin</li>
              <li>Koordinatör onayından sonra rezervasyonunuz kesinleşecek</li>
            </ol>
          </div>
        </div>
      </div>

      {/* Uyarı */}
      <div className="p-3 bg-red-900/20 border border-red-700/50 rounded-lg">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div className="text-xs text-red-200">
            <strong>Önemli:</strong> Geçersiz veya sahte dekont yüklemek ciddi yaptırımlara sebep olur. 
            Lütfen sadece gerçek havale dekontlarını yükleyiniz.
          </div>
        </div>
      </div>
    </div>
  );
};

export default IBANDisplay;
